import type {Nullable} from '../../../../utils/utility-types';
import type {FileModel} from '../../../domain/File/File.model';

export abstract class ReadFileQuery {
  abstract exec(props: ReadFileQuery.Props): Promise<FileModel>;
}

export namespace ReadFileQuery {
  export type Props = {
    authorId?: Nullable<string>;
    fileId: string;
  };
}
